/**
 * These index corresponds to the Components.indices array.
 * If you need to update it, please update Components.indices too,
 * and vice-versa.
 */
export enum IndexSortBy {
  Default = 0,
  PriceAsc = 1,
  PriceDesc = 2,
  Recent = 3
}
